"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_SERVICES_OR_SPECIALTIES_DATA = exports.SERVICES_DATA = exports.SPECIALTIES_DATA = exports.ServiceNameSpanish = exports.SpecialtyNameSpanish = exports.ServiceNameEnglish = exports.SpecialtyNameEnglish = exports.ServiceOrSpecialty = exports.MembershipUsageResponseDTO = exports.MembershipUsageRequestDTO = void 0;
class MembershipUsageRequestDTO {
    constructor(startDate, endDate, groupIds, specialties, services) {
        this.startDate = startDate;
        this.endDate = endDate;
        this.groupIds = groupIds;
        this.specialties = specialties;
        this.services = services;
    }
}
exports.MembershipUsageRequestDTO = MembershipUsageRequestDTO;
class MembershipUsageResponseDTO {
    constructor(requestedSpecialties, requestedServices, nonRequestedSpecialties, nonRequestedServices) {
        this.requestedSpecialties = requestedSpecialties;
        this.requestedServices = requestedServices;
        this.nonRequestedSpecialties = nonRequestedSpecialties;
        this.nonRequestedServices = nonRequestedServices;
    }
}
exports.MembershipUsageResponseDTO = MembershipUsageResponseDTO;
var ServiceOrSpecialty;
(function (ServiceOrSpecialty) {
    ServiceOrSpecialty["SERVICE"] = "service";
    ServiceOrSpecialty["SPECIALTY"] = "specialty";
})(ServiceOrSpecialty || (exports.ServiceOrSpecialty = ServiceOrSpecialty = {}));
var SpecialtyNameEnglish;
(function (SpecialtyNameEnglish) {
    SpecialtyNameEnglish["ALLERGOLOGY"] = "ALLERGOLOGY";
    SpecialtyNameEnglish["ANGIOLOGY"] = "ANGIOLOGY";
    SpecialtyNameEnglish["AUDIOMETRY"] = "AUDIOMETRY";
    SpecialtyNameEnglish["BARIATRICS"] = "BARIATRICS";
    SpecialtyNameEnglish["CARDIOLOGY"] = "CARDIOLOGY";
    SpecialtyNameEnglish["COLOPROCTOLOGY"] = "COLOPROCTOLOGY";
    SpecialtyNameEnglish["DENTISTRY"] = "DENTISTRY";
    SpecialtyNameEnglish["DERMATOLOGY"] = "DERMATOLOGY";
    SpecialtyNameEnglish["ENDOCRINOLOGY"] = "ENDOCRINOLOGY";
    SpecialtyNameEnglish["GASTROENTEROLOGY"] = "GASTROENTEROLOGY";
    SpecialtyNameEnglish["GENERAL_SURGERY"] = "GENERAL SURGERY";
    SpecialtyNameEnglish["GENERAL_MEDICINE"] = "GENERAL_MEDICINE";
    SpecialtyNameEnglish["GERIATRICS"] = "GERIATRICS";
    SpecialtyNameEnglish["GYNECOLOGY"] = "GYNECOLOGY";
    SpecialtyNameEnglish["HEMATOLOGY"] = "HEMATOLOGY";
    SpecialtyNameEnglish["IMMUNOLOGY"] = "IMMUNOLOGY";
    SpecialtyNameEnglish["INFECTOLOGY"] = "INFECTOLOGY";
    SpecialtyNameEnglish["INTERNAL_MEDICINE"] = "INTERNAL MEDICINE";
    SpecialtyNameEnglish["NEPHROLOGY"] = "NEPHROLOGY";
    SpecialtyNameEnglish["NEUROLOGY"] = "NEUROLOGY";
    SpecialtyNameEnglish["OFTALMOLOGY"] = "OFTALMOLOGY";
    SpecialtyNameEnglish["ONCOLOGY"] = "ONCOLOGY";
    SpecialtyNameEnglish["ORTHOPEDICS"] = "ORTHOPEDICS";
    SpecialtyNameEnglish["OTORHINOLARYNGOLOGY"] = "OTORHINOLARYNGOLOGY";
    SpecialtyNameEnglish["PEDIATRICS"] = "PEDIATRICS";
    SpecialtyNameEnglish["PHYSIOTHERAPY"] = "PHYSIOTHERAPY";
    SpecialtyNameEnglish["PSYCHIATRY"] = "PSYCHIATRY";
    SpecialtyNameEnglish["PSYCHOLOGY"] = "PSYCHOLOGY";
    SpecialtyNameEnglish["PULMONOLOGY"] = "PULMONOLOGY";
    SpecialtyNameEnglish["REHABILITATION"] = "REHABILITATION";
    SpecialtyNameEnglish["RHEUMATOLOGY"] = "RHEUMATOLOGY";
    SpecialtyNameEnglish["UROLOGY"] = "UROLOGY";
    SpecialtyNameEnglish["VACCINE"] = "VACCINE";
})(SpecialtyNameEnglish || (exports.SpecialtyNameEnglish = SpecialtyNameEnglish = {}));
var ServiceNameEnglish;
(function (ServiceNameEnglish) {
    ServiceNameEnglish["AMBULANCE"] = "AMBULANCE";
    ServiceNameEnglish["CHECK_UP"] = "CHECK UP";
    ServiceNameEnglish["DENTAL_CLEANING"] = "DENTAL CLEANING";
    ServiceNameEnglish["DOCTOR_AT_HOME"] = "DOCTOR_AT_HOME";
    ServiceNameEnglish["FUNERAL_ASSISTANCE"] = "FUNERAL ASSISTANCE";
    ServiceNameEnglish["LABORATORY"] = "LABORATORY";
    ServiceNameEnglish["NUTRITION"] = "NUTRITION";
    ServiceNameEnglish["OPTICS"] = "OPTICS";
    ServiceNameEnglish["PHARMACY"] = "PHARMACY";
    ServiceNameEnglish["TELEPHONE_CONSULTATION"] = "TELEPHONE CONSULTATION";
})(ServiceNameEnglish || (exports.ServiceNameEnglish = ServiceNameEnglish = {}));
var SpecialtyNameSpanish;
(function (SpecialtyNameSpanish) {
    SpecialtyNameSpanish["ALLERGOLOGY"] = "ALERGOLOGIA";
    SpecialtyNameSpanish["ANGIOLOGY"] = "ANGIOLOGIA";
    SpecialtyNameSpanish["AUDIOMETRY"] = "AUDIOMETRIA";
    SpecialtyNameSpanish["BARIATRICS"] = "BARIATRIA";
    SpecialtyNameSpanish["CARDIOLOGY"] = "CARDIOLOGIA";
    SpecialtyNameSpanish["COLOPROCTOLOGY"] = "COLOPROCTOLOGIA";
    SpecialtyNameSpanish["DENTISTRY"] = "ODONTOLOGIA";
    SpecialtyNameSpanish["DERMATOLOGY"] = "DERMATOLOGIA";
    SpecialtyNameSpanish["ENDOCRINOLOGY"] = "ENDOCRINOLOGIA";
    SpecialtyNameSpanish["GASTROENTEROLOGY"] = "GASTROENTEROLOGIA";
    SpecialtyNameSpanish["GENERAL_SURGERY"] = "CIRUGIA GENERAL";
    SpecialtyNameSpanish["GENERAL_MEDICINE"] = "MEDICO GENERAL";
    SpecialtyNameSpanish["GERIATRICS"] = "GERIATRIA";
    SpecialtyNameSpanish["GYNECOLOGY"] = "GINECOLOGIA";
    SpecialtyNameSpanish["HEMATOLOGY"] = "HEMATOLOGIA";
    SpecialtyNameSpanish["IMMUNOLOGY"] = "INMUNOLOGIA";
    SpecialtyNameSpanish["INFECTOLOGY"] = "INFECTOLOGIA";
    SpecialtyNameSpanish["INTERNAL_MEDICINE"] = "MEDICINA INTERNA";
    SpecialtyNameSpanish["NEPHROLOGY"] = "NEFROLOGIA";
    SpecialtyNameSpanish["NEUROLOGY"] = "NEUROLOGIA";
    SpecialtyNameSpanish["OFTALMOLOGY"] = "OFTALMOLOGIA";
    SpecialtyNameSpanish["ONCOLOGY"] = "ONCOLOGIA";
    SpecialtyNameSpanish["ORTHOPEDICS"] = "ORTOPEDIA";
    SpecialtyNameSpanish["OTORHINOLARYNGOLOGY"] = "OTORRINO";
    SpecialtyNameSpanish["PEDIATRICS"] = "PEDIATRIA";
    SpecialtyNameSpanish["PHYSIOTHERAPY"] = "FISIOTERAPIA";
    SpecialtyNameSpanish["PSYCHIATRY"] = "PSIQUIATRIA";
    SpecialtyNameSpanish["PSYCHOLOGY"] = "PSICOLOGIA";
    SpecialtyNameSpanish["PULMONOLOGY"] = "NEUMOLOGIA";
    SpecialtyNameSpanish["REHABILITATION"] = "REHABILITACION";
    SpecialtyNameSpanish["RHEUMATOLOGY"] = "REUMATOLOGIA";
    SpecialtyNameSpanish["UROLOGY"] = "UROLOGIA";
    SpecialtyNameSpanish["VACCINE"] = "VACUNA";
})(SpecialtyNameSpanish || (exports.SpecialtyNameSpanish = SpecialtyNameSpanish = {}));
var ServiceNameSpanish;
(function (ServiceNameSpanish) {
    ServiceNameSpanish["AMBULANCE"] = "AMBULANCIA";
    ServiceNameSpanish["CHECK_UP"] = "CHECK UP";
    ServiceNameSpanish["DENTAL_CLEANING"] = "LIMPIEZA DENTAL";
    ServiceNameSpanish["DOCTOR_AT_HOME"] = "MEDICO A DOMICILIO";
    ServiceNameSpanish["FUNERAL_ASSISTANCE"] = "ASISTENCIA FUNERARIA";
    ServiceNameSpanish["LABORATORY"] = "LABORATORIOS";
    ServiceNameSpanish["NUTRITION"] = "NUTRICION";
    ServiceNameSpanish["OPTICS"] = "OPTICAS";
    ServiceNameSpanish["PHARMACY"] = "FARMACIAS";
    ServiceNameSpanish["TELEPHONE_CONSULTATION"] = "CONSULTA TELEFONICA";
})(ServiceNameSpanish || (exports.ServiceNameSpanish = ServiceNameSpanish = {}));
exports.SPECIALTIES_DATA = [
    {
        type: ServiceOrSpecialty.SPECIALTY,
        nameEN: SpecialtyNameEnglish.ALLERGOLOGY,
        nameES: SpecialtyNameSpanish.ALLERGOLOGY,
    },
    {
        type: ServiceOrSpecialty.SPECIALTY,
        nameEN: SpecialtyNameEnglish.ANGIOLOGY,
        nameES: SpecialtyNameSpanish.ANGIOLOGY,
    },
    {
        type: ServiceOrSpecialty.SPECIALTY,
        nameEN: SpecialtyNameEnglish.AUDIOMETRY,
        nameES: SpecialtyNameSpanish.AUDIOMETRY,
    },
    {
        type: ServiceOrSpecialty.SPECIALTY,
        nameEN: SpecialtyNameEnglish.BARIATRICS,
        nameES: SpecialtyNameSpanish.BARIATRICS,
    },
    {
        type: ServiceOrSpecialty.SPECIALTY,
        nameEN: SpecialtyNameEnglish.CARDIOLOGY,
        nameES: SpecialtyNameSpanish.CARDIOLOGY,
    },
    {
        type: ServiceOrSpecialty.SPECIALTY,
        nameEN: SpecialtyNameEnglish.COLOPROCTOLOGY,
        nameES: SpecialtyNameSpanish.COLOPROCTOLOGY,
    },
    {
        type: ServiceOrSpecialty.SPECIALTY,
        nameEN: SpecialtyNameEnglish.DENTISTRY,
        nameES: SpecialtyNameSpanish.DENTISTRY,
    },
    {
        type: ServiceOrSpecialty.SPECIALTY,
        nameEN: SpecialtyNameEnglish.DERMATOLOGY,
        nameES: SpecialtyNameSpanish.DERMATOLOGY,
    },
    {
        type: ServiceOrSpecialty.SPECIALTY,
        nameEN: SpecialtyNameEnglish.ENDOCRINOLOGY,
        nameES: SpecialtyNameSpanish.ENDOCRINOLOGY,
    },
    {
        type: ServiceOrSpecialty.SPECIALTY,
        nameEN: SpecialtyNameEnglish.GASTROENTEROLOGY,
        nameES: SpecialtyNameSpanish.GASTROENTEROLOGY,
    },
    {
        type: ServiceOrSpecialty.SPECIALTY,
        nameEN: SpecialtyNameEnglish.GENERAL_SURGERY,
        nameES: SpecialtyNameSpanish.GENERAL_SURGERY,
    },
    {
        type: ServiceOrSpecialty.SPECIALTY,
        nameEN: SpecialtyNameEnglish.GENERAL_MEDICINE,
        nameES: SpecialtyNameSpanish.GENERAL_MEDICINE,
    },
    {
        type: ServiceOrSpecialty.SPECIALTY,
        nameEN: SpecialtyNameEnglish.GERIATRICS,
        nameES: SpecialtyNameSpanish.GERIATRICS,
    },
    {
        type: ServiceOrSpecialty.SPECIALTY,
        nameEN: SpecialtyNameEnglish.GYNECOLOGY,
        nameES: SpecialtyNameSpanish.GYNECOLOGY,
    },
    {
        type: ServiceOrSpecialty.SPECIALTY,
        nameEN: SpecialtyNameEnglish.HEMATOLOGY,
        nameES: SpecialtyNameSpanish.HEMATOLOGY,
    },
    {
        type: ServiceOrSpecialty.SPECIALTY,
        nameEN: SpecialtyNameEnglish.IMMUNOLOGY,
        nameES: SpecialtyNameSpanish.IMMUNOLOGY,
    },
    {
        type: ServiceOrSpecialty.SPECIALTY,
        nameEN: SpecialtyNameEnglish.INFECTOLOGY,
        nameES: SpecialtyNameSpanish.INFECTOLOGY,
    },
    {
        type: ServiceOrSpecialty.SPECIALTY,
        nameEN: SpecialtyNameEnglish.INTERNAL_MEDICINE,
        nameES: SpecialtyNameSpanish.INTERNAL_MEDICINE,
    },
    {
        type: ServiceOrSpecialty.SPECIALTY,
        nameEN: SpecialtyNameEnglish.NEPHROLOGY,
        nameES: SpecialtyNameSpanish.NEPHROLOGY,
    },
    {
        type: ServiceOrSpecialty.SPECIALTY,
        nameEN: SpecialtyNameEnglish.NEUROLOGY,
        nameES: SpecialtyNameSpanish.NEUROLOGY,
    },
    {
        type: ServiceOrSpecialty.SPECIALTY,
        nameEN: SpecialtyNameEnglish.OFTALMOLOGY,
        nameES: SpecialtyNameSpanish.OFTALMOLOGY,
    },
    {
        type: ServiceOrSpecialty.SPECIALTY,
        nameEN: SpecialtyNameEnglish.ONCOLOGY,
        nameES: SpecialtyNameSpanish.ONCOLOGY,
    },
    {
        type: ServiceOrSpecialty.SPECIALTY,
        nameEN: SpecialtyNameEnglish.ORTHOPEDICS,
        nameES: SpecialtyNameSpanish.ORTHOPEDICS,
    },
    {
        type: ServiceOrSpecialty.SPECIALTY,
        nameEN: SpecialtyNameEnglish.OTORHINOLARYNGOLOGY,
        nameES: SpecialtyNameSpanish.OTORHINOLARYNGOLOGY,
    },
    {
        type: ServiceOrSpecialty.SPECIALTY,
        nameEN: SpecialtyNameEnglish.PEDIATRICS,
        nameES: SpecialtyNameSpanish.PEDIATRICS,
    },
    {
        type: ServiceOrSpecialty.SPECIALTY,
        nameEN: SpecialtyNameEnglish.PHYSIOTHERAPY,
        nameES: SpecialtyNameSpanish.PHYSIOTHERAPY,
    },
    {
        type: ServiceOrSpecialty.SPECIALTY,
        nameEN: SpecialtyNameEnglish.PSYCHIATRY,
        nameES: SpecialtyNameSpanish.PSYCHIATRY,
    },
    {
        type: ServiceOrSpecialty.SPECIALTY,
        nameEN: SpecialtyNameEnglish.PSYCHOLOGY,
        nameES: SpecialtyNameSpanish.PSYCHOLOGY,
    },
    {
        type: ServiceOrSpecialty.SPECIALTY,
        nameEN: SpecialtyNameEnglish.PULMONOLOGY,
        nameES: SpecialtyNameSpanish.PULMONOLOGY,
    },
    {
        type: ServiceOrSpecialty.SPECIALTY,
        nameEN: SpecialtyNameEnglish.REHABILITATION,
        nameES: SpecialtyNameSpanish.REHABILITATION,
    },
    {
        type: ServiceOrSpecialty.SPECIALTY,
        nameEN: SpecialtyNameEnglish.RHEUMATOLOGY,
        nameES: SpecialtyNameSpanish.RHEUMATOLOGY,
    },
    {
        type: ServiceOrSpecialty.SPECIALTY,
        nameEN: SpecialtyNameEnglish.UROLOGY,
        nameES: SpecialtyNameSpanish.UROLOGY,
    },
    {
        type: ServiceOrSpecialty.SPECIALTY,
        nameEN: SpecialtyNameEnglish.VACCINE,
        nameES: SpecialtyNameSpanish.VACCINE,
    },
];
exports.SERVICES_DATA = [
    {
        type: ServiceOrSpecialty.SERVICE,
        nameEN: ServiceNameEnglish.AMBULANCE,
        nameES: ServiceNameSpanish.AMBULANCE,
    },
    {
        type: ServiceOrSpecialty.SERVICE,
        nameEN: ServiceNameEnglish.CHECK_UP,
        nameES: ServiceNameSpanish.CHECK_UP,
    },
    {
        type: ServiceOrSpecialty.SERVICE,
        nameEN: ServiceNameEnglish.DENTAL_CLEANING,
        nameES: ServiceNameSpanish.DENTAL_CLEANING,
    },
    {
        type: ServiceOrSpecialty.SERVICE,
        nameEN: ServiceNameEnglish.DOCTOR_AT_HOME,
        nameES: ServiceNameSpanish.DOCTOR_AT_HOME,
    },
    {
        type: ServiceOrSpecialty.SERVICE,
        nameEN: ServiceNameEnglish.FUNERAL_ASSISTANCE,
        nameES: ServiceNameSpanish.FUNERAL_ASSISTANCE,
    },
    {
        type: ServiceOrSpecialty.SERVICE,
        nameEN: ServiceNameEnglish.LABORATORY,
        nameES: ServiceNameSpanish.LABORATORY,
    },
    {
        type: ServiceOrSpecialty.SERVICE,
        nameEN: ServiceNameEnglish.NUTRITION,
        nameES: ServiceNameSpanish.NUTRITION,
    },
    {
        type: ServiceOrSpecialty.SERVICE,
        nameEN: ServiceNameEnglish.OPTICS,
        nameES: ServiceNameSpanish.OPTICS,
    },
    {
        type: ServiceOrSpecialty.SERVICE,
        nameEN: ServiceNameEnglish.PHARMACY,
        nameES: ServiceNameSpanish.PHARMACY,
    },
    {
        type: ServiceOrSpecialty.SERVICE,
        nameEN: ServiceNameEnglish.TELEPHONE_CONSULTATION,
        nameES: ServiceNameSpanish.TELEPHONE_CONSULTATION,
    },
];
exports.ALL_SERVICES_OR_SPECIALTIES_DATA = [
    ...exports.SPECIALTIES_DATA,
    ...exports.SERVICES_DATA,
];
//# sourceMappingURL=membership-usage-dto.js.map